module.exports = __webpack_public_path__ + "static/media/backCircle.8418dee7.svg";